import { DEFAULT_PREFIX } from "./constants.js";
const UNIQUE_ID_MAP = {};
function getUniqueString(prefix = DEFAULT_PREFIX) {
  let id = UNIQUE_ID_MAP[prefix];
  if (!id) {
    id = 0;
    UNIQUE_ID_MAP[prefix] = id;
  }
  return `${prefix}${UNIQUE_ID_MAP[prefix]++}`;
}
function typeOfMemberValue(value) {
  if (value === void 0 || value === null) {
    return null;
  }
  const type = typeof value;
  switch (type) {
    case "symbol": {
      return value.toString();
    }
    case "object": {
      return Array.isArray(value) ? "array" : "object";
    }
    default:
      return type;
  }
}
function enumerateGroups(handler, groups) {
  Object.entries(groups).forEach(([group, entries]) => {
    entries == null ? void 0 : entries.forEach((entry) => {
      handler(group, entry);
    });
  });
}
export {
  enumerateGroups,
  getUniqueString,
  typeOfMemberValue
};
//# sourceMappingURL=utils.js.map
